<mat-chip-list>
  <mat-chip *ngIf="record" class="successChip">
    <div class="successCheck">
      <span> REC <i class="fa-solid fa-square-check"></i> </span>
    </div>
  </mat-chip>
  <mat-chip *ngIf="!record" class="dangerChip">
    <div class="dangerCheck">
      <span> REC <i class="fa-solid fa-square-x"></i> </span>
    </div>
  </mat-chip>
</mat-chip-list>
